import { showToast, jump, showConfirm, showAlert } from '../../common';
import localStorage from '../storage/localStorage';
import sessionStorage from '../storage/sessionStorage';

/**
 * 当前是否已经选过城市（id = -1 是各页面约定的「还没选过城市」标记）
 */
function hasChoosedCity() {
  const sessionCity = sessionStorage.get('current_city') || {};
  const storedCity = localStorage.get('lastLocationCityInfo') || {};
  const id = sessionCity.id || storedCity.id;
  return !!id && +id !== -1;
}

export function doJump(url, redirect) {
  if (/^https?.+/.test(url)) {
    if (redirect) {
      const gap = url.includes('?') ? '&' : '?';
      url = `${url}${gap}redirect_url=${encodeURIComponent(
        window.location.href
      )}`;
    }
    window.location.href = url;
  } else {
    jump(url, redirect);
  }
}

let hasShowLogout = false;
function doAction(response) {
  const { header, body } = response;
  let { message, url, code } = header;
  const rsg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');

  if (!rsg.test(message)) {
    message = '';
  }

  // 返回code10003时，拦截页面，回到登录页
  if (+code == 10003 && message.indexOf('重新登录') !== -1) {
    if (!hasShowLogout) {
      // 原来漏了置位：同一请求里 doAction 会被调用两次（这里 + 响应处理的尾部），
      // 会出现同一条「请重新登录」弹两次（15000 分支是有置位的）
      hasShowLogout = true;
      showToast({ message });
      setTimeout(() => {
        localStorage.remove('session_info');
        // 若是登录页无需重定向
        if (location.pathname !== '/login') {
          jump('/login?redirect_url=' + encodeURIComponent(location.href));
        } else {
          jump('/login');
        }
        hasShowLogout = false;
      }, 2000);
    }
    return;
  }
  return {
    jump: () => {
      const redirect = true;
      if (code == 50002) {
        let data = body;
        // 保存token后跳转
        const date = new Date().getTime();
        data.expires_in = date + data.expires_in * 1000;
        localStorage.set('session_info', data);
        doJump(url, redirect);
      } else {
        if (message) {
          showToast({ message });
          setTimeout(() => {
            doJump(url, redirect);
          }, 2000);
        } else {
          doJump(url, redirect);
        }
      }
    },
    toast: () => {
      if (message) {
        showToast({ message });
      }
    },
    jumpWithoutRedirect: () => {
      if (message) {
        showToast({ message });
        // setTimeout(() => {
        //   doJump(url);
        // }, 2000);
      } else {
        // doJump(url);
      }
    }
  };
}

/**
 * @param {object} response 接口响应（信封 { header, body } 或平铺 { code, data }）
 * @param {object} options 本次请求的额外选项，见 utils/request/index.js
 */
export function handleResponse(response = {}, options = {}) {
  return new Promise((resolve, reject) => {
    // 兼容「平铺响应」{ code, message, data }：h5 侧所有接口都是这个结构
    // （h5 lib/request/handleResponse.js 读的就是 response.data.dialog / response.data），
    // 而本项目主网关多数接口是信封 { header, body }，但个别接口实测是平铺
    // （如 /v2/order/submit：返回 { code, message, data:{ order_sn } }）。
    // 不兼容就会出现「接口明明返回了 dialog / order_sn，客户端却当成失败 reject」——
    // 表现就是后端下发的卡券限制提示弹不出来、下单成功后也不跳支付页。
    // 判定条件用「没有 header 且有 code」，对信封响应零影响。
    const isFlat = !response.header && response.code !== undefined;
    const res = isFlat
      ? {
          header: { code: response.code, message: response.message },
          body: response.data || {}
        }
      : response;
    const { header = {}, body = {} } = res;
    const { code, action, message } = header;
    // if(body.goods_number) {
    //   body.dialog = {
    //     buttons:[
    //       {text:'我知道了'},
    //       {text:'去查看',action:'jump',url:'/userCenter/cards'}
    //     ],
    //     description:'当前卡卷不支持在该频道购买产品，请在个人中心我的卡卷详情中查看卡卷可用范围！',
    //     title:'温馨提示'
    //   }
    // }
    // 请求成功后的数据拦截，需要对数据中的dialog做处理。
    // options.skipAutoDialog：本次请求的 dialog 交还页面自己决定弹的时机
    // （例：/v1/ju/movies/theater 的「下单提醒」要等用户点「去支付」再弹，
    //  否则接口一返回就弹出来，等于「进页面就弹」），传了就不在这里自动弹
    if (!options.skipAutoDialog && body.dialog && body.dialog != '') {
      let obj = {};
      if (body.dialog.title) obj.title = body.dialog.title;
      if (body.dialog.description) obj.content = body.dialog.description;
      if (body.dialog.buttons && body.dialog.buttons != '') {
        let i = 0;
        if (body.dialog.buttons.length > 1) {
          obj.cancelText = body.dialog.buttons[i].text;
          obj.cancelBtn = body.dialog.buttons[i];
        } else {
          i = -1;
        }
        obj.okBtn = body.dialog.buttons[i + 1];
        obj.okText = body.dialog.buttons[i + 1].text;
      }
      showConfirm(obj)
        .then(() => {
          if (obj.okBtn.action && obj.okBtn.action === 'jump') {
            obj.okBtn.url && jump(obj.okBtn.url);
          }
        })
        .catch(() => {
          if (obj.cancelBtn.action && obj.cancelBtn.action === 'jump') {
            obj.cancelBtn.url && jump(obj.cancelBtn.url);
          }
        });
    }
    if (+code === 0) {
      resolve(body);
    } else if (+code === 15000) {
      if (!hasShowLogout) {
        hasShowLogout = true;
        showToast({
          message: '登录已失效，请重新登录'
        });
        setTimeout(() => {
          localStorage.remove('session_info');
          // 若是登录页无需重定向
          if (location.pathname !== '/login') {
            jump('/login?redirect_url=' + encodeURIComponent(location.href));
          } else {
            jump('/login');
          }
          hasShowLogout = false;
        }, 2000);
      }
    } else if (code == 50002) {
      if (action == 'token') {
        // 保存token后跳转
        const date = new Date().getTime();
        let data = body;
        data.expires_in = date + data.expires_in * 1000;
        localStorage.set('session_info', data);
        resolve();
      } else if (typeof doAction(res)[action] === 'function') {
        doAction(res)[action]();
      }
    } else if (code == -2) {
      showToast({
        message: '网络异常'
      });
      reject(res);
    } else {
      // 非 0 码且没有 action 分支：按 h5 handleResponse 的口径自动把后端的文案提示出来
      //   h5：message.length < 15 → showToast；否则 showConfirm({ showCancel: false })，
      //   且可用 hidemessage 关掉（本项目对应 options.hideMessage）。
      // 之前这里只有 reject，页面 catch 里又普遍是空函数 → 后端的提示（如
      // 「商品不可售：未匹配到可配送门店」/order/submit 10003）就完全弹不出来。
      // 不重复提示的几种情况：
      //   1) 响应带 action（jump / token / confirm …）→ 交给下面 doAction 统一处理；
      //   2) 10003 且文案含「重新登录」→ doAction 里已提示并会跳登录页；
      //   3) 10008 / 10009 → 购物车地址类错误，由页面自己弹引导弹窗（见 cart/index.vue）。
      const actionHandler = (doAction(res) || {})[action];
      const isRelogin =
        +code === 10003 && String(message).indexOf('重新登录') !== -1;
      const isCartAddress = [10008, 10009].indexOf(+code) !== -1;
      // 4) 城市还没选时，后端会返回「city_id 不能为空」这类提示。此时页面已用
      //    「定位失败 → 手动选择城市」的引导在提示用户，这里再弹一条只是重复噪音
      const isCityRequired =
        !hasChoosedCity() && /city[\s_]*id/i.test(String(message));
      if (
        typeof actionHandler !== 'function' &&
        !options.hideMessage &&
        !isRelogin &&
        !isCartAddress &&
        !isCityRequired &&
        message
      ) {
        if (String(message).length < 15) {
          showToast({ message });
        } else {
          // 长文案用只读弹窗（单个「确定」），避免 toast 3 秒就消失看不全
          showAlert(message);
        }
      }
      reject(res);
    }
    if ([10008, 10009].indexOf(+code) !== -1) {
      return;
    }
    // doAction 在「10003 + 重新登录」分支里返回 undefined，直接取下标会抛 TypeError；
    // 同时这里只取一次，避免同一请求两次构造 action 处理
    const actionFn = doAction(res) || {};
    if (typeof actionFn[action] === 'function') {
      actionFn[action]();
    }
  });
}
let hasShowLogout_hx = false;
export function hx_handleResponse(response = {}) {
  return new Promise((resolve, reject) => {
    let code;
    let header = response.header;
    let body = {};
    if (!header) {
      code = response.code;
      body = response;
    } else {
      code = header.code;
      body = response.body;
    }
    if (body.message) {
      showToast({
        message: body.message
      });
    }
    if (+code === 0) {
      resolve(body);
    } else if (+code === 15000) {
      if (!hasShowLogout_hx) {
        hasShowLogout_hx = true;
        showToast({
          message: '登录已失效，请重新登录'
        });
        setTimeout(() => {
          localStorage.remove('session_hx_info');
          // 若是登录页无需重定向
          jump('/writeoff/login');
          hasShowLogout_hx = false;
        }, 2000);
      }
    } else if (code == -2) {
      showToast({
        message: '网络异常'
      });
      reject(response);
    } else {
      reject(response);
    }
  });
}
